/**
 * enum that specifies that locale date format mostly used with moment
 */
export enum AllowedLocaleDateFormats {
  DE = 'de',
  /**
   * british date format for english
   */
  EN = 'en_GB',
}
